import $ from 'jquery';
import {
  onStartAnimation,
  onCancelAnimation,
  onHideObjectAnimation,
  onEffectFadeIn,
  onEffectSlideInFromLeft,
  onEffectSlideInFromRight,
  onEffectSlideInFromTop,
  onEffectSlideInFromBottom,
  onEffectFadeOut,
  onChangeMusic,
  onChangeVideo,
} from '~video';
import { getState, getStatePure, modifyState } from '~src/state';
import { triggerStateChangedRequest } from '~core';
import { handleSidebarBackgrounds } from '~src/sidebar/index';
import { FEATURES, isFeatureEnabled } from '../features';

export const initVideoEventListener = () => {
  $('body').on(
    'click',
    '#editor-menu-object-start-animation',
    onStartAnimation
  );
  $('body').on('click', '#editor-menu-object-animation', onStartAnimation);
  $('body').on('click', '#editor-menu-finish-animation', onStartAnimation);
  $('body').on('click', '#editor-menu-cancel-animation', onCancelAnimation);
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-hide',
    onHideObjectAnimation
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-fadeIn',
    onEffectFadeIn
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-fadeOut',
    onEffectFadeOut
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-slideInFromLeft',
    onEffectSlideInFromLeft
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-slideInFromRight',
    onEffectSlideInFromRight
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-slideInFromBottom',
    onEffectSlideInFromBottom
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-effect-slideInFromTop',
    onEffectSlideInFromTop
  );

  $('body').on('click', '[data-animation-delete]', (event) => {
    const index = $(event.currentTarget).data('animation-index');
    const pages = getStatePure('pages');
    const currentPageIndex = getState('currentPageIndex');
    pages[currentPageIndex].animations.splice(index, 1);
    modifyState('pages', pages);
    triggerStateChangedRequest();
  });

  $('body').on('change', '[data-animation-duration-control]', (event) => {
    const duration = parseFloat($(event.currentTarget).val());
    const index = $(event.currentTarget).data('animation-index');
    const pages = getStatePure('pages');
    const currentPageIndex = getState('currentPageIndex');
    pages[currentPageIndex].animations[index].toProps.duration = duration;
    modifyState('pages', pages);
    triggerStateChangedRequest();
  });

  $('body').on(
    'click',
    '#editor-sidebar-animation-change-music',
    onChangeMusic
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-change-video',
    onChangeVideo
  );
  $('body').on(
    'click',
    '#editor-sidebar-animation-change-video-with-image',
    async () => {
      await handleSidebarBackgrounds();
    }
  );

  $('body').on('click', '#editor-sidebar-animation-remove-music', () => {
    modifyState('soundtrackId', '');
    triggerStateChangedRequest();
  });

  isFeatureEnabled(FEATURES.VIDEOS_ADVANCED_CREATOR_MODE).then(
    (isAdvancedCreatorMode) => {
      if (isAdvancedCreatorMode) {
        $('#editor-menu-object-start-animation').removeClass('d-none');
        $('#editor-sidebar-advanced-animations').show();
      }
    }
  );
};
